import React, { FC, ReactElement } from 'react';
import Dialog from '@material-ui/core/Dialog';

interface IModalProps {
  trigger?: ReactElement;
  modalContent: ReactElement;
  isOpen: boolean;
  modalOpen: () => void;
  withoutBackground?: boolean;
}
const Modal: FC<IModalProps> = ({
  trigger,
  modalContent,
  isOpen,
  modalOpen,
  withoutBackground,
}) => {
  return (
    <div>
      <div tabIndex={0} role="button" onKeyDown={modalOpen} onClick={modalOpen}>
        {trigger}
      </div>
      <Dialog
        PaperProps={
          withoutBackground
            ? {
                style: {
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                },
              }
            : {}
        }
        open={isOpen}
        onClose={modalOpen}
      >
        {modalContent}
      </Dialog>
    </div>
  );
};

export default Modal;
